export const SET_SESSION = 'SET_SESSION';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const REFRESH_SESSION = 'REFRESH_SESSION';
export const REFRESH_SESSION_SUCCESS = 'REFRESH_SESSION_SUCCESS';
export const REFRESH_SESSION_FAILED = 'REFRESH_SESSION_FAILED';
export const RETRY_ACTION = 'RETRY_ACTION';
